import * as Yup from "yup";

const ResetPasswordFormSchema = () => {
  return Yup.object().shape({
    password: Yup.string()
      .min(8, "Hasło musi mieć co najmniej 8 znaków")
      .max(72, "Hasło może mieć maksymalnie 72 znaki")
      .minNumbers(1, "Hasło musi mieć co najmniej 1 cyfrę")
      .required("Hasło jest wymagane"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Hasła muszą się zgadzać")
      .required("Potwierdzenie hasła jest wymagane"),
  });
};

export default ResetPasswordFormSchema;
